let navigateFn = null;

// Stocker la fonction de navigation de React Router
export const setNavigator = (fn) => {
  if (typeof fn === 'function') {
    navigateFn = fn;
  } else if (fn && typeof fn.navigate === 'function') {
    // Si on reçoit l'objet navigate de React Router v6
    navigateFn = (to, options) => {
      if (options?.replace) {
        fn.navigate(to, { replace: true });
      } else {
        fn.navigate(to);
      }
    };
  } else {
    navigateFn = null;
  }
};

// Fonction de navigation sécurisée
export const navigateTo = (path, options = { replace: true }) => {
  try {
    if (navigateFn) {
      navigateFn(path, options);
    } else if (typeof window !== 'undefined' && window.location) {
      if (options.replace) {
        window.location.replace(path);
      } else {
        window.location.href = path;
      }
    }
  } catch (error) {
    console.error('Navigation error:', error);
    if (typeof window !== 'undefined' && window.location) {
      window.location.href = path;
    }
  }
};

// Initialiser window.navigateTo si non défini
if (typeof window !== 'undefined' && !window.navigateTo) {
  window.navigateTo = navigateTo;
}

